// FooterInfo.js
import React from 'react';
import Instantstart from './../Public/Image/Home/Instantstart.svg'
import Bestquality from './../Public/Image/Home/Bestquality.svg'
import Ongoingsupport from './../Public/Image/Home/Ongoingsupport.svg'

export default function FooterInfo() {
  return (
    <div className="FooterContent">
      <div className="FooterContentTitle">You deserve the best:</div>
      <div className="FooterContentItems">
        <FooterItem img={Instantstart} label="Instant start" />
        <FooterItem img={Bestquality} label="Best quality" className="Bestquality" />
        <FooterItem img={Ongoingsupport} label="Ongoing support" />
      </div>
    </div>
  );
}

function FooterItem({ img, label, className = "" }) {
  return (
    <div className={`FooterContentItem ${className}`}>
      <img src={img} className="FooterContentItemPic" alt={label} />
      <div>{label}</div>
    </div>
  );
}
